export default __webpack_public_path__ + "static/media/5.c964743e.png";